module.exports = __webpack_public_path__ + "static/media/1_A1_25.9af5f349.png";